import tv, { SchemaType } from "typed-object-validator";

export const GlobalServerSettingsSchema = tv.object({
    markRunningAfterSatisfy: tv.boolean(),
});
export type GlobalServerSettings = SchemaType<typeof GlobalServerSettingsSchema>;

export const GlobalClientSettingsSchema = tv.object({
    disableUserUpdateBirthDate: tv.boolean(),
    maintenanceMode: tv.boolean(),
});
export type GlobalClientSettings = SchemaType<typeof GlobalClientSettingsSchema>;

export const GlobalSettingsSchema = tv.object({
    server: GlobalServerSettingsSchema,
    client: GlobalClientSettingsSchema,
});
export type GlobalSettings = SchemaType<typeof GlobalSettingsSchema>;
